import { DependencyList, useEffect, useState } from "react";
import { useBaaanggg } from "./BaaangggHook";
import { Baaanggg } from "baaanggg";

export enum FetchStatus {
    Success,
    Failed,
    Loading,
    Init
}

export function errorPromise(): Promise<undefined> {
    return new Promise((_, rej) => rej())
}

export function useApi<T>(fetcher: (baaanggg: Baaanggg) => Promise<T | undefined>, deps?: DependencyList) {
    const [status, setStatus] = useState(FetchStatus.Init)
    const [data, setData] = useState<T>()
    const baaanggg = useBaaanggg()

    const fetchData = async () => {
        try {
            setData(undefined)
            setStatus(FetchStatus.Loading)
            const data = await fetcher(baaanggg)
            setData(data)
            setStatus(FetchStatus.Success)
        } catch (e) {
            setStatus(FetchStatus.Failed)
        }
    }

    useEffect(() => {
        fetchData()
    }, [...(deps ?? [])])

    return {
        refresh: fetchData,
        data,
        status
    }
}